import { lazy } from 'react'
import { useSelector } from 'react-redux'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const offerFormByCountryAndType = {
  'energy-fr': lazy(() => import('./Energy/FR/EnergyOfferForm')),
  'energy-be': lazy(() => import('./Energy/BE/EnergyOfferForm')),
  'energy-de': lazy(() => import('./Energy/DE/EnergyOfferForm')),
  'energy-it': lazy(() => import('./Energy/IT/EnergyOfferForm')),
  'energy-nl': lazy(() => import('./Energy/NL/EnergyOfferForm')),
  'telecom-fr': lazy(() => import('./Telecom/FR/TelecomOfferForm')),
  'telecom-it': lazy(() => import('./Telecom/IT/TelecomOfferForm')),
  'telecom-be': lazy(() => import('./Telecom/BE/TelecomOfferForm')),
  'insurance-fr': lazy(() => import('./Insurance/FR/InsuranceOfferForm')),
  'insurance-be': lazy(() => import('./Insurance/BE/InsuranceOfferForm')),
}

const useOfferEditForm = () => {
  const { getApplicationTypeFolder } = useBusinessType({
    loaderRoutesEnergy: {},
    loaderRoutes: {},
    loaderRoutesInsurance: {},
  })
  const { country } = useSelector(selectAuthData)
  const moduleKey = `${getApplicationTypeFolder().toLowerCase()}-${country?.toLowerCase()}`
  const LocalizedModule = offerFormByCountryAndType[moduleKey] ?? null

  return { LocalizedModule }
}

export default useOfferEditForm
